import React from "react";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { getBlockLabel, getBlockTypeConfig } from "../../config/blockTypes";
import type { PlatformBlockType } from "../../types";

interface BlockFormHeaderProps {
  blockType: PlatformBlockType;
  /** Текущие (живые) props блока — для вида-зависимого заголовка (CONTENTS). */
  props?: Record<string, unknown> | null;
}

export const BlockFormHeader: React.FC<BlockFormHeaderProps> = ({
  blockType,
  props,
}) => {
  const { t } = useTranslation();
  const config = getBlockTypeConfig(blockType);
  if (!config) return null;
  const label = getBlockLabel({ component: blockType, props }, t);
  return (
    <Stack spacing={0.25} sx={{ mb: 2 }}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Box
          sx={{
            display: "flex",
            "& .MuiSvgIcon-root": { fontSize: 28 },
          }}
        >
          {config.icon}
        </Box>
        <Typography variant="h6">{label}</Typography>
      </Stack>
      {config.notRendered && (
        <Typography variant="caption" color="warning.main">
          {t("platformBlocks.item.notRendered")}
        </Typography>
      )}
    </Stack>
  );
};
